import React from "react";

export const discoContent = (
  <div>
    <p className="content justified">
      Oswaldo Díaz Díaz tuvo una relación muy cercana con la Radiodifusora Nacional de Colombia, en donde participó como
      director, libretista y narrador.
    </p>
    <p className="content justified">
      Algunos de sus radioteatros fueron presentados, además, en radio Sutatenza y en la HJCK.
    </p>
    <p className="content justified">
      Fue libretista de las series de radioteatro <i>Cuentos y leyendas</i> y <i>Leyendas</i>, para las que escribió
      obras originales y adaptaciones dirigidas a niños y adultos.
    </p>
    <p className="content justified">
      Uno de sus programas más conocidos fue <em>Por aquí pasó Bolívar</em>, transmitido entre 1958 y 1959. Esta serie
      es una muestra de su interés por la historia y su anhelo de difusión.
    </p>
  </div>
);
